import {
  Component,
  Output,
  EventEmitter,
  OnInit,
  ViewChild,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { BaseConfigProvider } from '../../providers/base-config/base-config';
import { Message } from '../../class/task';
import {Platform, NavController} from 'ionic-angular/index';
import { WxProvider } from '../../providers/wx/wx';
import { MyAlertProvider } from '../../providers/my-alert/my-alert';
import {global} from "../../environments/global";
import {UtilProvider} from "../../providers/util/util";
import {ChooseMaterialPage} from "../../pages/choose-material/choose-material";
declare var $: any;
declare var wx: any;

/**
 * Generated class for the MsgSendComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'msg-send',
  templateUrl: 'msg-send.html',
  providers: [WxProvider],
})
export class MsgSendComponent implements OnInit, OnChanges {
  @Output() newMsg = new EventEmitter();
  @Output() showEdit = new EventEmitter();


  @Input() editMaxSize: number;
  // @Input() content:any;
  @Input() msg: any;

  @Input() height: any;

  @Input() onlyText:number;
  temp_msg: Message;

  @ViewChild('editPre') editPre: ElementRef;
  @ViewChild('changeEdit') changeEdit: ElementRef;
  @ViewChild('emoji') emoji: ElementRef;
  // @ViewChild(Content) content: Content;
  constructor(public platform:Platform, public util:UtilProvider,public navCtrl:NavController,public myAlert:MyAlertProvider,public wxService:WxProvider) {
    $('body').click(_ =>{
      this.is_show_add_box = false;
    });
    $('.scroll-content').on('scroll', _ =>{
      $('.send-content-box').focus();
    })
  }
  ngOnInit() {
    // this.getSignature();
    $('#editBox').on('touchstart', () => {
      $('#editBox').focus();
    });
  }

  // getSignature(){
  //   this.wxService.getSignature().subscribe(res =>{
  //     wx.config({
  //       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //       appId: global.app_id, // 必填，公众号的唯一标识
  //       timestamp: res['content']['timestamp'], // 必填，生成签名的时间戳
  //       nonceStr: res['content']['nonceStr'], // 必填，生成签名的随机串
  //       signature: res['content']['signature'], // 必填，签名
  //       jsApiList: [
  //         'chooseImage',
  //         'uploadImage',
  //         'getLocalImgData',
  //         'downloadImage',
  //       ], // 必填，需要使用的JS接口列表
  //     });
  //   });
  // }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['msg']) {
      // this.msg = {
      //   text_string:'',
      // };
      this.temp_msg = new Message();
      // this.initHeight();
    }
    this.editMaxSize = this.editMaxSize || 1000;
  }


  addNewTextMsg() {
    this.temp_msg.real_type = 1;
    let text = this.editPre.nativeElement.innerHTML
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<br>/g, '\n')
      .replace(/<div>/g, '\n')
      .replace(/&nbsp;/g, '')
      .replace(/&emsp;/g, '')
      .replace(/&ensp;/g, '')
      .replace(/<\/div>/g, '')
      .replace(/<\/?[^\u4e00-\u9fa5]+>/g, '')
      .replace(/<\/?.+font-.+?\/?>/g, '')
      .replace(/[\u202d\u202e\u2060\ufeff\u202c]/g, '').trim();

    if (text.length == 0) {
      let alertObj = {
        type: 'warning',
        title: '文本消息不能为空',
        message: '不能添加空的文本消息！',
        success: {
          text: '知道了',
        },
      };
      this.myAlert.showAlert(alertObj);
    }
    else if(text.length > 0 &&this.editMaxSize > text.length){
      this.msg.message_list.push(new Message({
        real_type:1,
        text:text}
      ));
      $('.my-text-input').empty();
      this.temp_msg = new Message();
    } else {
      let title = '';
      let message = '';

      if (this.editMaxSize == 30) {
        title = '签到消息太长！';
        message = '签到消息不能超过30个字';
      } else {
        title = '文本消息太长！';
        message = '文本消息不能超过' + this.editMaxSize + '个字';
      }

      let alertObj = {
        type: 'warning',
        title: title,
        message: message,
        success: {
          text: '知道了',
        },
      };
      this.myAlert.showAlert(alertObj);
    }
  }

  is_show_big_input: boolean;
  addNewBigTextMsg() {
    this.is_show_big_input = false;
    this.addNewTextMsg();
  }

  reorderItems(indexes) {
    let element = this.msg.message_list[indexes.from];
    this.msg.message_list.splice(indexes.from, 1);
    this.msg.message_list.splice(indexes.to, 0, element);
  }


  sendNewMsg(){
    setTimeout(() => {
      $('.text-input').empty();
    }, 100);
  }
  onFaceClick(classname, name) {
    const editArea = this.editPre.nativeElement;

    let node = document.createElement('img');
    node.src = './assets/my-imgs/spacer.gif';
    node.setAttribute('text', name);
    node.className = classname;

    if (editArea != document.activeElement) {
      editArea.appendChild(node);
      return;
    }

    if (window.getSelection) {
      // let sel = window.getSelection();
      // let range = sel.getRangeAt(0);
      // range.insertNode(node);

      let sel = window.getSelection();
      let range = sel.getRangeAt(0);
      range.insertNode(node);
      sel.removeAllRanges();
      let newRange = document.createRange();
      newRange.setStartAfter(node);
      sel.addRange(newRange);
    }
  }
  selectEmoticon(e) {
    var a = e.target;
    if ('A' == a.tagName) {
      var i = a.innerText || a.textContent,
        r = a.getAttribute('type');
      switch (r) {
        case 'qq':
          i = '[' + i + ']';
          this.getEmoticonByText(i);
          break;
        case 'emoji':
          i = '<' + i + '>';
          this.getEmoticonByText(i);
          break;
      }
      e.preventDefault();
    }
  }

  getEmoticonByText(name) {
    var t;
    if (name.indexOf('<') > -1) {
      if ((t = BaseConfigProvider.QQFaceMap[name]))
        // console.log(SendMsgComponent.EmojiCodeMap[t]);
        return this.onFaceClick(
          'emoji emoji' + t,
          BaseConfigProvider.EmojiCodeMap[t]
        );
    } else if ((t = BaseConfigProvider.QQFaceMap[name.replace(/\[|\]/g, '')]))
      return this.onFaceClick('qqemoji qqemoji' + t, name);
    return null;
  }

  // get faces2() {
  //   return SendMsgComponent.Faces2;
  // }
  send() {
    this.newMsg.emit(this.msg);
  }

  editMsg: Message;
  show_edit_box;
  editText(msg) {
    if (msg.real_type == 1) {
      this.editMsg = msg;
      this.msg_length = this.editMsg.text.length;
      this.show_edit_box = true;
      this.showEdit.emit(true);
    }
  }

  deleteMsg(index) {
    let alertObj = {
      type: 'confirm',
      title: '确认删除此条消息？',
      message: '删除后将无法恢复！',
      success: {
        text: '删除',
        callback: () => {
          this.msg.message_list.splice(index, 1);
        },
      },
      fail: {
        text: '取消',
      },
    };
    this.myAlert.showAlert(alertObj);
  }

  cancelEdit() {
    this.show_edit_box = false;
    this.showEdit.emit(false);

    // this.editMsg = null;
  }
  saveEdit() {
    let text = this.changeEdit.nativeElement.value
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<br>/g, '\n')
      .replace(/<div>/g, '\n')
      .replace(/&nbsp;/g, '')
      .replace(/&emsp;/g, '')
      .replace(/&ensp;/g, '')
      .replace(/<\/div>/g, '')
      .replace(/<\/?[^\u4e00-\u9fa5]+>/g, '')
      .replace(/<\/?.+font-.+?\/?>/g, '')
      .replace(/[\u202d\u202e\u2060\ufeff\u202c]/g, '').trim();
    if (text.length == 0) {
      let alertObj = {
        type: 'warning',
        title: '消息不能为空！',
        message: '空消息无法保存！',
        success: {
          text: '知道了',
        },
      };
      this.myAlert.showAlert(alertObj);
    } else if (text.length <= this.editMaxSize) {
      this.editMsg.text = text;
      this.cancelEdit();
    } else {
      let title = '';
      let message = '';

      if (this.editMaxSize == 30) {
        title = '签到消息太长';
        message = '签到消息不能超过30个字';
      } else {
        title = '文本消息太长';
        message = '文本消息不能超过'+ this.editMaxSize +'个字';
      }

      let alertObj = {
        type: 'warning',
        title: title,
        message: message,
        success: {
          text: '知道了',
        },
      };
      this.myAlert.showAlert(alertObj);
    }
  }



  msg_length;
  getEditMsgLength() {
    if (this.changeEdit) {
      this.msg_length = this.changeEdit.nativeElement.value
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/<br>/g, '\n')
        .replace(/<div>/g, '\n')
        .replace(/&nbsp;/g, '')
        .replace(/&emsp;/g, '')
        .replace(/&ensp;/g, '')
        .replace(/<\/div>/g, '')
        .replace(/<\/?[^\u4e00-\u9fa5]+>/g, '')
        .replace(/<\/?.+font-.+?\/?>/g, '')
        .replace(/[\u202d\u202e\u2060\ufeff\u202c]/g, '').trim().length;
    }
    // return length;
  }


  material_list = global.material_type;

  is_show_add_box = false;

  showAddMaterialBox(e) {
    e.stopPropagation();
    this.is_show_add_box = !this.is_show_add_box;
  }

  getText(e) {
    this.temp_msg.text = e.target.innerHTML
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/<br>/g, '\n')
      .replace(/<div>/g, '\n')
      .replace(/&nbsp;/g, '')
      .replace(/&emsp;/g, '')
      .replace(/&ensp;/g, '')
      .replace(/<\/div>/g, '')
      .replace(/<\/?[^\u4e00-\u9fa5]+>/g, '')
      .replace(/<\/?.+font-.+?\/?>/g, '')
      .replace(/[\u202d\u202e\u2060\ufeff\u202c]/g, '').trim();
  }



  chooseMaterial(index){
    console.log(index);
    this.navCtrl.push(ChooseMaterialPage,{
      message_list: this.msg.message_list || [],
      material_index:index,
      saveMessage: (msg_list) =>{
        this.msg.message_list = msg_list.map(item => {
          if(item.real_content && item.real_type != 1){
            item.text = item.real_content;
          }
          return item;
        });
      }
    });
    // this.util.myNav(this.navCtrl,, );
  }
  // is_focus;
  // initInputPos(e){
  //   //input  获取焦点时调整input 位置
  //   this.is_show_add_box = false;
  //   if(this.platform.is('ios')){
  //     this.is_focus = false;
  //   }
  // }
  //
  // resetInputPos(e){
  //
  //   if(this.platform.is('ios')){
  //     setTimeout(()=>{
  //
  //       let body_scroll = $('body').scrollTop();
  //
  //
  //       if(BaseConfigProvider.is_weixin() && body_scroll )
  //         this.is_focus = true;
  //     },100);
  //   }
  // }

  clearText(e) {
    e.preventDefault();

    let text = e.clipboardData.getData('text/plain');

    document.execCommand('insertHTML', false, text);
  }

  modelChange(){
    setTimeout(()=>{
      document.body.scrollTop = document.body.scrollHeight;
    },300);
  }

  inputBlur(){
    document.body.scrollTop = 0;
    let currentPosition,timer;
    let speed=1;//页面滚动距离
    timer=setInterval(function(){
      currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition-=speed;
      window.scrollTo(0,0);//页面向上滚动
      clearInterval(timer);
    },1);
  }

  myInputClick(){
    // this.is_show_add_box = false;
    setTimeout(()=>{
      document.body.scrollTop = document.body.scrollHeight;
    },300);
  }
}



// WEBPACK FOOTER //
// ./src/components/msg-send/msg-send.ts